<template>
  <v-list
    nav
    class="d-flex flex-column fill-height my-0 py-0"
  >
    <!-- Logo as first “item” -->
    <v-list-item>
      <v-list-item>
        <v-img
          src="@/assets/images/logo.dark.horizontal.png"
          alt="Logo"
          max-width="120"
          contain
        />
      </v-list-item>
    </v-list-item>

    <v-divider class="pt-2" />
    <!-- Navigation links -->
    <v-list-item
      v-for="item in regularItems"
      :key="item.name"
      :to="item.route"
      :prepend-icon="item.icon"
      :aria-label="
        itemNeedsAuthIndicator(item)
          ? `${item.label} - ${t('auth.protectedNavLabel')}`
          : item.label
      "
      :title="item.label"
      link
    >
      <template
        v-if="itemNeedsAuthIndicator(item)"
        #append
      >
        <v-tooltip
          :text="t('auth.protectedNavLabel')"
          location="end"
        >
          <template #activator="{ props }">
            <v-icon
              v-bind="props"
              class="nf nf-fa-lock protected-nav-lock"
              aria-hidden="true"
            />
          </template>
        </v-tooltip>
      </template>
    </v-list-item>

    <v-divider />
    <v-spacer />
    <!-- Navigation links -->
    <v-list-item
      :key="authLink.name"
      :to="authLink.route"
      :prepend-icon="authLink.icon"
      :base-color="authLink.color"
      :title="authLink.label"
      variant="flat"
      link
    />
  </v-list>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import { useAuthLink } from '@/presentation/composables/navigation/useAuthLink';

const { t } = useI18n();

// 1. Primary nav items (always present)
const regularItems = [
  {
    name: 'pomodoro',
    route: { name: 'pomodoro' },
    icon: 'fas fa-stopwatch',
    label: 'Pomodoro',
    requiresAuth: false
  },
  {
    name: 'todo',
    route: { name: 'todo' },
    icon: 'fas fa-tasks',
    label: 'ToDo',
    requiresAuth: true
  },
  {
    name: 'performance',
    route: { name: 'performance' },
    icon: 'fas fa-trophy',
    label: 'Performance',
    requiresAuth: true
  }
];

const authLink = useAuthLink();

/**
 * Keeps the protected-state decoration logic next to the nav definition so
 * public links stay visually clean and protected links remain understandable
 * before the user clicks into a login redirect.
 */
const itemNeedsAuthIndicator = (item) => {
  if (!item.requiresAuth) {
    return false;
  }

  return !authLink.value.authenticated;
};
</script>

<style scoped>
.protected-nav-lock {
  font-size: 0.9rem;
  opacity: 0.78;
}
</style>
